/* eslint-disable react/jsx-wrap-multilines */
import React, { Component } from "react";
import { ClickableBox, Paragraph, Bold } from "../Components";
import { getOrderForId } from "../selectors";
import { getTranslateByScope } from "../i18n";

import { get, post } from "../Api/requests";
import { endpoints } from "../endpoints";

const translate = getTranslateByScope("app.orderConfirmation");

const checkStatus = (id) =>
  get({ endpoint: endpoints.get_your_content.status(id) });

const generate = (id, params) =>
  post({ endpoint: endpoints.get_your_content.generate(id), params });

const downloadPath = (id) => endpoints.get_your_content.download(id);

export class ColourBookButton extends Component {
  state = {
    seed: Math.floor(Math.random() * 1000000),
  };

  onClick = () => {
    const { context } = this.props;
    let order = getOrderForId(context)(this.props.id);

    if (order === null || order === undefined) {
      return;
    }

    order = order.doc;
    order.currency = this.props.currency;

    generate(this.props.id + "-" + this.state.seed, order)
      .then(() => {
        this.setState({ colourBookStatus: "started" });
        this.checkOrderStatus();
      })
      .catch(() => {
        this.setState({ colourBookStatus: "error" });
      });
  };

  checkOrderStatus = () => {
    checkStatus(this.props.id + "-" + this.state.seed)
      .then((d) => {
        const { status } = d.data;
        this.setState({ colourBookStatus: status });

        if (status === "started") {
          setTimeout(() => {
            this.checkOrderStatus();
          }, 5000);
        }
      })
      .catch(() => {
        console.log("color book error");
      });
  };

  componentDidMount() {
    this.checkOrderStatus();
  }

  render() {
    if (this.state.colourBookStatus === "started") {
      return (
        <Bold style={{ whiteSpace: "nowrap" }}>
          {translate("generatingColorbook")}
        </Bold>
      );
    }

    if (this.state.colourBookStatus === "finished") {
      return (
        <div>
          <a
            style={{ whiteSpace: "nowrap" }}
            rel="noopener noreferrer"
            href={downloadPath(this.props.id + "-" + this.state.seed)}
            target="_blank"
          >
            <Paragraph>{translate("downloadColorbook")}</Paragraph>
          </a>
        </div>
      );
    }

    return (
      <ClickableBox style={{ fontWeight: "bold" }} onClick={this.onClick}>
        {translate("generateColorbook")}
      </ClickableBox>
    );
  }
}
